/* eslint-disable i18next/no-literal-string */
import {Select} from '@dropbox/dig-components/text_fields';
import {useQuery} from '@tanstack/react-query';
import {AdminWorkstreamImporterService} from 'client';
import {getService} from 'utilities';

import styles from './AdminWorkstreamImporterTimeframeSelect.module.css';

/** Picks the planning timeframe (narrative root) the import is created under. */
export const AdminWorkstreamImporterTimeframeSelect = ({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (timeframe: string) => void;
  disabled?: boolean;
}) => {
  const {data: timeframes = [], isLoading} = useQuery({
    queryKey: ['admin-workstream-importer-timeframes'],
    queryFn: () =>
      getService(
        AdminWorkstreamImporterService
      ).listWorkstreamImportTimeframesApiV1AdminWorkstreamImporterTimeframesGet(),
  });

  return (
    <div className={styles.timeframeSelect}>
      <Select
        id="workstream-importer-timeframe"
        aria-label="Timeframe"
        value={value}
        placeholder="Select timeframe"
        onChange={onChange}
        disabled={disabled || isLoading}
      >
        {timeframes.map((option) => (
          <Select.Option key={option.timeframe} value={option.timeframe}>
            {option.timeframe}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
